@let $appendTo = appendTo();
@let $disabledSecretKey = disabledSecretKey();
@let $initialSettings = initialSettings();
@let $readonly = readonly();
@let $showHelpButton = showHelpButton();
@let $storageLink = storageLink();
@let $storageType = storageTypeCtrl.value;

<ng-container [formGroup]="formGroup()">
  @let controls = formGroup().controls;

  @if ($initialSettings) {
    <mbs-alert
      [icon]="true"
      [type]="MbsPopupType.info">
      {{ moduleAccount + ':sidepanel.text.changeStorageAccount' | i18next: { format: 'capitalize' } }}{{ $showHelpButton ? '.' : '' }}
      @if ($showHelpButton && manageStorageLink) {
        <a
          class="text-nowrap"
          rel="noopener noreferrer"
          target="_blank"
          [href]="manageStorageLink">
          {{ moduleButton + ':button.learnMore' | i18next: { format: 'capitalize' } }}
        </a>
      }
    </mbs-alert>
  } @else {
    <mbs-alert
      [icon]="true"
      [type]="MbsPopupType.info">
      {{ moduleAccount + ':sidepanel.text.addStorageAccount' | i18next: { format: 'capitalize' } }}
    </mbs-alert>
  }

  <mbs-form-group>
    <mbs-select
      [appendTo]="$appendTo"
      [bindLabel]="'DisplayName'"
      [bindValue]="'Name'"
      [boldLabel]="true"
      [class.ng-select-disabled]="$readonly"
      [clearable]="false"
      [disabledSelf]="$readonly"
      [formControlName]="FormKey.StorageType"
      [hint]="($storageType | isAvailableRegion) && !$initialSettings ? hintTRef : null"
      [items]="storages()"
      [label]="moduleAccount + ':sidepanel.label.storageAccount' | i18next: { format: 'capitalize' }"
      [searchable]="false"
      [showRequiredMark]="false"
      [style.pointer-events]="$readonly ? 'none' : 'initial'" />
    <ng-template #hintTRef>
      @if (storageTypeCtrl.value === StorageType.WasabiUnifiedBilling) {
        {{ moduleAccount + ':sidepanel.text.addUBStorage.description_Wasabi' | i18next: { format: 'capitalize' } }}:
      } @else {
        {{ moduleAccount + ':sidepanel.text.addUBStorage.description_AmazonS3' | i18next: { format: 'capitalize' } }}:
      }
      <ul class="mb-0">
        <li>
          {{
            moduleAccount + ':sidepanel.text.addUBStorage.cost'
              | i18next
                : {
                    format: 'capitalize',
                    price: priceGB() | priceToDisplay,
                    totalPrice: priceTB() | priceToDisplay
                  }
          }}
        </li>
        @if (storageTypeCtrl.value === StorageType.WasabiUnifiedBilling) {
          <li>
            {{ moduleAccount + ':sidepanel.text.addUBStorage.lessDataSize' | i18next: { format: 'capitalize' } }}
          </li>
          <li>
            {{ moduleAccount + ':sidepanel.text.addUBStorage.moreDataSize' | i18next: { format: 'capitalize' } }}
          </li>
        } @else {
          <li>
            {{ moduleAccount + ':sidepanel.text.addUBStorage.payment' | i18next: { format: 'capitalize' } }}
          </li>
        }
        <li>
          {{ moduleAccount + ':sidepanel.text.addUBStorage.postpaid' | i18next: { format: 'capitalize' } }}
        </li>
        <li>
          {{ moduleAccount + ':sidepanel.text.addUBStorage.cancel' | i18next: { format: 'capitalize' } }}{{ $showHelpButton ? '.' : '' }}

          @if ($showHelpButton && $storageLink) {
            <a
              class="text-nowrap"
              rel="noopener noreferrer"
              target="_blank"
              [href]="$storageLink">
              {{ moduleButton + ':button.learnMore' | i18next: { format: 'capitalize' } }}
            </a>
          }
        </li>
      </ul>
    </ng-template>
  </mbs-form-group>

  @if (controls[FormKey.Region].enabled) {
    <!--    <mbs-form-group [class.mb-0]="!$initialSettings">-->
    <mbs-form-group class="mb-0">
      <mbs-select
        [appendTo]="$appendTo"
        [bindLabel]="'DisplayName'"
        [bindValue]="'SystemName'"
        [boldLabel]="true"
        [class.ng-select-disabled]="$readonly"
        [clearable]="false"
        [disabledSelf]="$readonly"
        [formControlName]="FormKey.Region"
        [items]="regions()"
        [label]="moduleAccount + ':sidepanel.label.region' | i18next: { format: 'capitalize' }"
        [placeholder]="moduleAccount + ':sidepanel.placeholder.region' | i18next: { format: 'capitalize' }"
        [searchable]="false"
        [showRequiredMark]="false"
        [style.pointer-events]="$readonly ? 'none' : 'initial'" />
    </mbs-form-group>

    <!--    @if ($initialSettings) {-->
    <!--      <mbs-form-group-->
    <!--        [title]="moduleAccount + ':sidepanel.label.dataSizeOnStorage' | i18next: { format: 'capitalize' }"-->
    <!--        [titleClasses]="'fw-bold mb-0'"-->
    <!--        [class.mb-0]="$initialSettings">-->
    <!--        {{ sizeBytes() | size }}-->
    <!--      </mbs-form-group>-->
    <!--    }-->
  }

  @if (controls[FormKey.Name].enabled) {
    <mbs-form-group>
      <mbs-input
        [boldLabel]="true"
        [formControlName]="FormKey.Name"
        [label]="moduleAccount + ':sidepanel.label.displayName' | i18next: { format: 'capitalize' }"
        [placeholder]="moduleAccount + ':sidepanel.placeholder.displayName' | i18next: { format: 'capitalize' }"
        [showRequiredMark]="false"
        [type]="'text'" />
    </mbs-form-group>
  }

  @if (controls[FormKey.BucketName].enabled) {
    <mbs-form-group>
      <mbs-input
        [boldLabel]="true"
        [disabledSelf]="$readonly"
        [formControlName]="FormKey.BucketName"
        [label]="$storageType | bucketNameText: 'label'"
        [placeholder]="$storageType | bucketNameText: 'placeholder'"
        [showRequiredMark]="false"
        [type]="'text'" />
    </mbs-form-group>
  }

  @if (controls[FormKey.RootFolder].enabled) {
    <mbs-form-group>
      <mbs-input
        [boldLabel]="true"
        [disabledSelf]="$readonly"
        [formControlName]="FormKey.RootFolder"
        [label]="moduleAccount + ':sidepanel.label.rootFolder' | i18next: { format: 'capitalize' }"
        [placeholder]="moduleAccount + ':sidepanel.placeholder.rootFolder' | i18next: { format: 'capitalize' }"
        [showRequiredMark]="false"
        [type]="'text'" />
    </mbs-form-group>
  }

  @if (controls[FormKey.AccessKey].enabled) {
    <mbs-form-group>
      <mbs-input
        [boldLabel]="true"
        [formControlName]="FormKey.AccessKey"
        [label]="$storageType | accessKeyText: 'label'"
        [placeholder]="$storageType | accessKeyText: 'placeholder'"
        [showRequiredMark]="false"
        [type]="'text'" />
    </mbs-form-group>
  }

  @if (controls[FormKey.SecretKey].enabled) {
    <mbs-form-group [class.mb-0]="!controls[FormKey.Endpoint].enabled && !controls[FormKey.EndpointSuffix].enabled">
      <mbs-input
        [appendButtons]="[
          {
            id: 'append-secret-key',
            type: 'secondary',
            icon: $disabledSecretKey ? secretKeyIconClasses.lock : secretKeyIconClasses.unlock,
            btnType: 'button',
            loading: false,
            disabled: false
          }
        ]"
        [boldLabel]="true"
        [disabledSelf]="$disabledSecretKey"
        [formControlName]="FormKey.SecretKey"
        [label]="$storageType | secretKeyText: 'label'"
        [placeholder]="$storageType | secretKeyText: 'placeholder'"
        [showRequiredMark]="false"
        [type]="$disabledSecretKey ? 'password' : 'text'"
        (buttonClick)="handleToggleDisabledSecretKey()" />
    </mbs-form-group>
  }

  @if (controls[FormKey.Endpoint].enabled) {
    <mbs-form-group [class.mb-0]="!controls[FormKey.EndpointSuffix].enabled">
      <mbs-input
        [boldLabel]="true"
        [formControlName]="FormKey.Endpoint"
        [label]="labelTRef"
        [placeholder]="moduleAccount + ':sidepanel.placeholder.endpoint' | i18next: { format: 'capitalize' }"
        [showRequiredMark]="false"
        [type]="'text'" />
      <ng-template #labelTRef>
        {{ moduleAccount + ':sidepanel.label.endpoint' | i18next: { format: 'capitalize' } }}
        <ng-container [ngTemplateOutlet]="labelOptionalTRef" />
      </ng-template>
    </mbs-form-group>
  }

  @if (controls[FormKey.EndpointSuffix].enabled) {
    <mbs-form-group class="mb-0">
      <mbs-input
        [boldLabel]="true"
        [formControlName]="FormKey.EndpointSuffix"
        [label]="labelTRef"
        [placeholder]="moduleAccount + ':sidepanel.placeholder.endpointSuffix' | i18next: { format: 'capitalize' }"
        [showRequiredMark]="false"
        [type]="'text'" />
      <ng-template #labelTRef>
        {{ moduleAccount + ':sidepanel.label.endpointSuffix' | i18next: { format: 'capitalize' } }}
        <ng-container [ngTemplateOutlet]="labelOptionalTRef" />
      </ng-template>
    </mbs-form-group>
  }
</ng-container>

<ng-template #labelOptionalTRef>
  <span class="text-sm text-gray-500"> ({{ moduleAccount + ':sidepanel.label.optional' | i18next: { format: 'capitalize' } }}) </span>
</ng-template>
